import { render, staticRenderFns } from "./ManageCollectionItemModal.vue?vue&type=template&id=dfe4a060&scoped=true&"
import script from "./ManageCollectionItemModal.vue?vue&type=script&lang=js&"
export * from "./ManageCollectionItemModal.vue?vue&type=script&lang=js&"
import style0 from "./ManageCollectionItemModal.vue?vue&type=style&index=0&id=dfe4a060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe4a060",
  null
  
)

export default component.exports